import {
  IconButton,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Text,
  VStack,
} from "@chakra-ui/react";
import { MdOutlineNotificationsActive } from "react-icons/md";

const Notifications = ({ notifications }) => {
  return (
    <Menu>
      <MenuButton
        _focus={{ outline: "none" }}
        as={IconButton}
        // borderColor="main_2"
        border={0}
        aria-label="Options"
        icon={<MdOutlineNotificationsActive color="#f7d723" fontSize="30px" />}
        variant="outline"
      />
      <MenuList width={500} h={400} overflowY="scroll" dir="rtl">
        {notifications?.data?.map((item, index) => {
          return (
            <MenuItem p="7px" mt="10px">
              <VStack spacing="7px" alignItems="start">
                <Text mx="5px">{item?.message}</Text>
              </VStack>
            </MenuItem>
          );
        })}

        <MenuDivider />
      </MenuList>
    </Menu>
  );
};

export default Notifications;
